import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  Divider,
  Collapse,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  PersonOutline,
  LockOutlined,
  Logout,
} from "@mui/icons-material";
import DashboardIcon from '@mui/icons-material/Dashboard';
import { styled } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import apiLinks from '../config/apiLinks.json';
import apiService from '../utils/apiService';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: 260,
    backgroundColor: "#fff",
    color: "#222",
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid #f0f0f0",
    direction: "rtl",
    textAlign: "right",
  },
}));

const FixedHeader = styled("div")(() => ({
  flexShrink: 0,
  backgroundColor: "#fff",
  position: "sticky",
  top: 0,
  zIndex: 10,
}));

const ScrollableContent = styled("div")(() => ({
  overflowY: "auto",
  flexGrow: 1,
}));


const Sidebar = ({ open, toggleSidebar }) => {
  const location = useLocation();

  const [accountOpen, setAccountOpen] = useState(false);
  const navigate = useNavigate();
  const { accessToken, autoLogin, FullName, logout } = useAuth();
  const [menuData, setMenuData] = useState([]);
  const iconMap = {
    ReceiptLongOutlinedIcon: ReceiptLongOutlinedIcon,
    LocalShippingOutlinedIcon: LocalShippingOutlinedIcon,
  };
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const data = await apiService.get(
          `${apiLinks.baseUrl}${apiLinks.Settings.GetMenus}`,
          {},
          autoLogin
        );
        if (data.Menus && data.Menus.length > 0) {
          setMenuData(data.Menus);
        }
      } catch (error) {
        // console.error("Error fetching menu:", error);
      }
    };

    fetchMenu();
  }, [accessToken]);
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  useEffect(() => {
    if (open) {
      toggleSidebar();
    }
  }, [location.pathname]);
  /* ================= JSX ================= */

  return (
    <StyledDrawer
      dir="rtl"
      variant="temporary"
      open={open}
      onClose={toggleSidebar}
      anchor="right"
      ModalProps={{
        keepMounted: true,
      }}
      SlideProps={{
        direction: "left",
      }}
    >
      {/* ===== Header (Logo + User) ===== */}
      <FixedHeader>
        <List sx={{ p: 0 }}>

          {/* User Avatar Section */}
          <ListItem
            sx={{
              flexDirection: "column",
              alignItems: "center",
              py: 3,
            }}
          >
            <Avatar
              src="/Images/user.jpg"
              sx={{
                width: 72,
                height: 72,
                mb: 1,
                border: "2px solid #f0f0f0",
              }}
            />
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600 }}
            >
              {FullName}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
            >
              کاربر سیستم
            </Typography>
          </ListItem>

          <Divider />

        </List>
      </FixedHeader>

      {/* ===== Scrollable Content ===== */}
      <ScrollableContent>
        <List sx={{ px: 2, pt: 2 }}>
          {/* ===== Account Section ===== */}
          <ListItem
            onClick={() => setAccountOpen(!accountOpen)}
            sx={{
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
              mb: 1,
              "&:hover": { backgroundColor: "#fdf3f4" },
            }}
          >

            <Box sx={{ flexGrow: 1, fontWeight: 600 }}>
              حساب کاربری
            </Box>
            {accountOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse
            in={accountOpen}
            timeout="auto"
            unmountOnExit
          >
            <List disablePadding>
              <ListItem
                component={Link}
                to="/profile"
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  mb: "7px",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <PersonOutline
                  fontSize="small"
                  sx={{ ml: 1 }}
                />
                مشاهده پروفایل
              </ListItem>

              <ListItem
                component={Link}
                to="/Account/ChangePassword"
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  mb: "7px",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <LockOutlined
                  fontSize="small"
                  sx={{ ml: 1 }}
                />
                تغییر رمز عبور
              </ListItem>

              <ListItem
                onClick={handleLogout}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  fontWeight :"500",
                  cursor:"pointer",
                  color: "#d32f2f",
                  "&:hover": {
                    backgroundColor: "#fdecea",
                  },
                }}
              >
                <Logout
                  fontSize="small"
                  sx={{ ml: 1 }}
                />
                خروج از حساب کاربری
              </ListItem>
            </List>
          </Collapse>

          <Divider sx={{ my: 2 }} />
          <ListItem
            key={"goDashboard"}
            component={Link}
            to={"/"}
            onClick={toggleSidebar}
            sx={{
              borderRadius: "8px",
              cursor: "pointer",
              mb: 1,
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
           <DashboardIcon />
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600 }}
            >
             داشبورد
            </Typography>

          </ListItem>
          {menuData.map((menu, index) => {
            const IconComponent = iconMap[menu.Menu_Icon];

            return (
              <ListItem
                key={menu.Menu_Id}
                component={Link}
                to={`/${menu.Menu_Controller?.toLowerCase()}`}
                onClick={toggleSidebar}
                sx={{
                  borderRadius: "8px",
                  cursor: "pointer",
                  mb: 1,
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                {IconComponent ? <IconComponent /> : <ReceiptLongOutlinedIcon />}
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600 }}
                >
                  {menu.Menu_text}
                </Typography>

              </ListItem>
            );
          })}
        </List>
      </ScrollableContent>
    </StyledDrawer>
  );
};
export default Sidebar;